/* fw-ipad-fix-20260703 */
class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));

    // iOS Safari only fires :hover on the first tap of an element that has
    // :hover CSS but no bound click/touch handler (a second tap is then
    // needed to actually activate it). The summary here and any nested
    // summaries (mega menu / list-menu dropdown) have :hover styling, which
    // can block opening the nav on iPad landscape (desktop breakpoint, touch
    // input). A no-op listener makes iOS treat them as directly tappable.
    this.querySelectorAll('summary').forEach((summary) => {
      summary.addEventListener('touchstart', () => {}, { passive: true });
    });

    // FW iPad/touch submenu fix 2026-07-03.
    // On touch devices at desktop widths (iPad landscape ≥990px), the native
    // focusout handler closes the <details> immediately after a tap because
    // programmatic .click() doesn't move focus inside the element.  We track
    // whether the current open was initiated by touch and, if so, suppress
    // focusout-driven closure — relying on an outside-tap listener instead.
    this._touchOpened = false;

    this.querySelectorAll('summary').forEach((summary) => {
      summary.addEventListener('touchend', () => {
        this._touchOpened = true;
      }, { passive: true, capture: true });
    });

    // Close on outside tap when touch-opened
    this._outsideTouchHandler = (e) => {
      if (!this.mainDetailsToggle.hasAttribute('open')) return;
      if (!this.mainDetailsToggle.contains(e.target)) {
        this._touchOpened = false;
        this.close();
      }
    };
    document.addEventListener('touchend', this._outsideTouchHandler, { passive: true, capture: true });
  }

  onFocusOut() {
    if (this._touchOpened) return; // touch devices: let outside-tap handle closing
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach(animation => animation.play());
    } else {
      this._touchOpened = false; // reset on close
      this.animations.forEach(animation => animation.cancel());
    }
  }

  close() {
    this._touchOpened = false;
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    super.onToggle();
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(this.header.getBoundingClientRect().bottom)}px`);
  }
}

customElements.define('header-menu', HeaderMenu);